module.exports = __webpack_public_path__ + "img/icons B_12.340ff1a2.png";